export default __webpack_public_path__ + "static/media/mccloskey.0279741e.mp4";